import { render, staticRenderFns } from "./ReservasPrincipal.vue?vue&type=template&id=d45d132c&scoped=true&"
import script from "./ReservasPrincipal.vue?vue&type=script&lang=js&"
export * from "./ReservasPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45d132c",
  null
  
)

export default component.exports